import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { RangeCustomEvent, RangeValue } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { CategoryResponse, CategoryStore } from 'src/app/stores/category.store';
import { ProductStore } from 'src/app/stores/product.store';
import { ProductCondition } from 'src/environments/environment';

@Component({
  selector: 'app-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: ['./category-filter.component.scss'],
})
export class CategoryFilterComponent implements OnInit {
  @Input() filterData: {
    category: number;
    today_deals: number;
    price_min: number;
    price_max: number;
    pickUp: number;
    delivery: number;
  };
  lastEmittedValue: RangeValue;
  priceRangeLower: number = null;
  priceRangeUpper: number = null;
  category: CategoryResponse;
  catId: number;
  sub_category: CategoryResponse;
  selectedSubCat: number;
  params: {
    category: number;
    today_deals: number;
    price_min: number;
    price_max: number;
    pickUp: number;
    delivery: number;
    condition: number;
    sub_category: number;
  };
  deals: string;
  shipping: string;
  @Input() categoryId: number;
  @Output() onFilterChanged = new EventEmitter();
  productCondition = ProductCondition;
  currentProductCondition: ProductCondition = ProductCondition.New;

  constructor(
    private modalCtrl: ModalController,
    private categoryStore: CategoryStore,
    private productStore: ProductStore,
    public translate: TranslateService,
    public platform: Platform,
    private auth: AuthenticationStore
  ) {
    this.auth.clearAll.subscribe((data) => {
      this.params = {
        category: null,
        today_deals: null,
        price_min: null,
        price_max: null,
        pickUp: null,
        delivery: null,
        condition: null,
        sub_category: null,
      };
      this.catId = null;
      this.deals = null;
      this.shipping = null;
      this.priceRangeLower = null;
      this.priceRangeUpper = null;
      this.changeFilter();
      this.auth.isClear.next('clear');
    });
  }
  ionViewDidEnter() {
    this.catId = this.filterData && this.filterData.category;
    this.deals = this.filterData
      ? this.filterData.today_deals == null
        ? '1'
        : '0'
      : null;
    this.shipping = this.filterData
      ? this.filterData.pickUp == null
        ? '1'
        : '0'
      : null;
    this.priceRangeLower = this.filterData?.price_min
      ? this.filterData.price_min
      : 20;
    this.priceRangeUpper = this.filterData?.price_max
      ? this.filterData.price_max
      : 500;
    if (this.catId) {
      this.categoryId = null;
    }
  }

  ngOnInit() {
    this.categorybatch();
    this.subCategorybatch()
  }

  onIonChange(ev: any) {
    this.priceRangeLower = ev.detail.value.lower;
    this.priceRangeUpper = ev.detail.value.upper;
    if (this.platform.is('desktop')) this.changeFilter();
  }

  async categorybatch() {
    this.category = await this.categoryStore.getCategory();
  }

  async subCategorybatch() {
    this.sub_category = await this.categoryStore.getSubCategoryList();
  }

  selectCat(value) {
    this.categoryId = null;
    this.catId = value.id;
    if (this.platform.is('desktop')) this.changeFilter();
  }

  selectSubCat(value) {
    this.selectedSubCat = null;
    this.selectedSubCat = value.id;
    if (this.platform.is('desktop')) this.changeFilter();
  }
  changeDeal() {
    this.deals = '0';
    this.changeFilter();
  }
  changeShippingMethod(event) {
    this.shipping = event.target.value;
    this.changeFilter();
  }
  changeFilter() {
    this.params = {
      category: this.catId,
      sub_category: this.selectedSubCat,
      today_deals: this.deals == '0' ? 1 : null,
      price_min: this.priceRangeLower,
      price_max: this.priceRangeUpper,
      pickUp: this.shipping == '0' ? 1 : null,
      delivery: this.shipping == '1' ? 1 : null,
      condition: this.currentProductCondition,
    };
    this.onFilterChanged.emit(this.params);
    this.auth.isClear.next('setClear');
  }

  changeValue(event) {
    this.currentProductCondition = event.target.value;
    this.changeFilter();
  }

  modaldismiss() {
    this.params = {
      category: this.catId,
      today_deals: this.deals == '0' ? 1 : null,
      price_min: this.priceRangeLower,
      price_max: this.priceRangeUpper,
      pickUp: this.shipping == '0' ? 1 : null,
      delivery: this.shipping == '1' ? 1 : null,
      sub_category: this.selectedSubCat,
      condition: this.currentProductCondition,
    };
    this.productStore.getProducts(this.params);
    this.modalCtrl.dismiss(this.params);
  }
}
